export const version = 'v1.1.04 09/30/25 1:47pm';